import {Box, styled} from '@mui/material';
import {StyledCard} from 'presentation/components';

export const CustomStyledCardContainer = styled(StyledCard.Container)`
	box-shadow: none;
`;

export const StyledFooterContainer = styled(Box)`
	margin: auto 0px 72px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;
